import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  listingId: number;
  targetLang: string;
  translator?: 'google' | 'deepl';
}

export interface ListingTranslationResponse {
  description: string;
}

export default (makeCall: MakeCall) => ({
  listingId,
  targetLang,
  translator,
}: Payload) =>
  makeCall<ListingTranslationResponse>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/translate/description/${targetLang}`,
    {
      query: {
        translator,
      },
    },
  );
